//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';
import AdListItemMixins from '~/mixins/ad-list-item';
export default {
  components: {
    HotColumn: () => import('~/components/column/hot-column'),
    ColumnArticle: () => import('~/components/column/column-article'),
    HotArticle: () => import('~/components/public/hot-article'),
  },
  mixins: [AdListItemMixins],
  async asyncData({ error, $axios }) {
    try {
      let [hotColumn, columnList, articleList] = await Promise.all([
        $axios(
          api.getHotColumns({
            page: 1,
            count: 5,
          })
        ),
        $axios(
          api.getRecommendColumns({
            page: 1,
            count: 9,
          })
        ),
        $axios(
          api.getColumnArticleList({
            page: 1,
            count: 16,
          })
        ),
      ]);
      hotColumn = hotColumn?.result ?? [];
      columnList = columnList?.result ?? [];
      articleList = articleList?.result ?? [];

      return {
        hotColumn,
        columnList,
        articleList,
      };
    } catch (err) {
      error({
        statusCode: 404,
        message: '文章不存在',
      });
    }
  },
  data() {
    return {
      hotColumnPage: 1,
      columnArticlePage: 1,
    };
  },
  head() {
    return {
      title: '格隆汇专栏-财经资讯专栏作家',
      meta: [
        {
          hid: 'keywords',
          name: 'keywords',
          content: `市场数据宏观分析,利率市场,债券分析`,
        },
        {
          hid: 'description',
          name: 'description',
          content:
            '格隆汇官网的专题栏目下针对市场数据宏观分析,利率市场,债券分析等外汇行业相关内容作出了详细的概括,如想要更加深入了解,可到格隆汇网站进行查阅分析.',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: 'https://www.gelonghui.com/column/',
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: 'https://m.gelonghui.com/column/',
        },
      ],
    };
  },

  computed: {
    articleListWithAd() {
      // 插入广告
      const test = this.insertAdToData(this.articleList, this.column_ad, 3, 9);
      return test;
    },
  },
  methods: {
    async changeHotColumn() {
      this.hotColumnPage = this.hotColumnPage === 9 ? 0 : this.hotColumnPage;
      const { result = [] } = await this.$axios(
        api.getHotColumns({
          page: this.hotColumnPage++,
          count: 5,
        })
      );
      this.hotColumn = result;
    },
    async moreArticle() {
      const { result = [] } = await this.$axios(
        api.getColumnArticleList({
          page: ++this.columnArticlePage,
          count: 16,
        })
      );
      this.articleList.push(...result);
    },
  },
};
